import { render, staticRenderFns } from "./PropostaTabelaItem.vue?vue&type=template&id=829abd38"
import script from "./PropostaTabelaItem.vue?vue&type=script&lang=js"
export * from "./PropostaTabelaItem.vue?vue&type=script&lang=js"
import style0 from "./PropostaTabelaItem.vue?vue&type=style&index=0&id=829abd38&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports